export class Language {
    constructor(json_obj) {
        this.id = json_obj["id"];
        this.name = json_obj["name"];
        this.short_name = json_obj["short_name"];
        this.municipality_name = json_obj["municipality_name"];
        this.iso_code = json_obj["iso_code"];
        this.disabled = json_obj["disabled"];
    }
    format_for_selectform() {
        return {
            value: this.id,
            text: this.name
        };
    }
}
